import { SITE_URL } from '../seo/siteUrl';

/**
 * Absolute URL for a client route path (matches canonical base in SeoHead).
 * @param {string} path - e.g. "/faqs" or "/apts-search-screen?city=hyderabad"
 */
export function pathToAbsoluteUrl(path) {
  if (path == null || path === '') return SITE_URL;
  const s = typeof path === 'string' ? path : '';
  if (/^https?:\/\//i.test(s)) return s;
  return `${SITE_URL}${s.startsWith('/') ? s : `/${s}`}`;
}

/**
 * schema.org BreadcrumbList for Google rich results.
 * @param {Array<{ label: string, path: string }>} items
 * @returns {object | null}
 */
export function buildBreadcrumbListJsonLd(items) {
  if (!Array.isArray(items) || items.length === 0) return null;

  const itemListElement = items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.label,
    item: pathToAbsoluteUrl(item.path),
  }));

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };
}
